export { EntityIcon, type EntityIconProps } from "./EntityIcon";
